module.exports = __webpack_public_path__ + "static/media/Gargoyle.01089e3f.jpg";